import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { BasicTimelines } from "../../../../Constant";
import { UL } from "../../../../AbstractElements";
import { DynamicBasicTimeline } from "./DynamicBasicTimeline";
import { StaticBasicTimeline } from "./StaticBasicTimeline";
import { BASIC_TIMELINE } from "../../../../Data/Bonus Ui/Timeline";

const   BasicTimeline = () => {
  return (
    <Col xl="6" sm="6" className="notification main-timeline">
      <Card>
        <CommonCardHeader title={BasicTimelines} span={BASIC_TIMELINE} />
        <CardBody className="dark-timeline">
          <UL className="simple-list">
            <StaticBasicTimeline />
            <DynamicBasicTimeline />
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};

export default BasicTimeline;
